<ion-header *ngIf="isMobile">
  <codere-navbar titulo=""> </codere-navbar>
</ion-header>

<ion-content [ngClass]="{'is-mobile': isMobile}">
  <div *ngIf="globalVars?.user?.logged" id="logged">
    <iframe [src]="iframeSrc" class="codere-fantasy-iframe" #iframeTarget></iframe>
  </div>

  <div *ngIf="!globalVars?.user?.logged" (click)="openLogin()" id="notlogged">
    <div class="overlay"></div>
    <iframe [src]="tempIframeSrc" class="codere-fantasy-iframe" #iframeTarget2 (click)="openLogin()"></iframe>
  </div>
  <codere-footer></codere-footer>
</ion-content>
